/** Modalidad de trabajo de la persona (#13995), en español. */
export const WORK_MODE_LABELS: Record<string, string> = {
	ON_SITE: "Presencial",
	REMOTE: "En remoto",
	HYBRID: "Híbrida",
};
